export default __webpack_public_path__ + "static/media/smiley_rating_excellent.f25e2cd7.svg";